import { WaitingUsersReducerState } from './waitingUsersReducer.types';

export const WAITING_USERS_REDUCER_INITIAL_STATE = Object.freeze<WaitingUsersReducerState>({
    hasReceivedWaitingUsers: {},
    waitingUsers: {},
    hasReceivedAllWaitingUsers: false,
});
